import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getNumericValue} from '../../../../common/util/fieldsValidation';

class Totals extends Component {
  getOrdersSum(suggestedOrders = []) {
    return suggestedOrders.reduce((result, order) => {
      return result + parseInt(order.partQuantity || 0, 10);
    }, 0);
  }

  getOrdersFee(suggestedOrders = []) {
    const orderTotalFob = suggestedOrders.reduce((result, order) => {
      return result + Number(order.totalFob || 0.0);
    }, 0.0);

    return getNumericValue(orderTotalFob, 2);
  }

  render() {
    const {suggestedOrders} = this.props;

    return (
      <React.Fragment>
        Totales:
        cantidad de líneas: {suggestedOrders.length},
        unidades del pedido: {this.getOrdersSum(suggestedOrders)},
        FOB total: $ {this.getOrdersFee(suggestedOrders)}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'suggestedOrders': state.providerStockOrders.suggestedOrders,
  };
};

export default connect(mapStateToProps)(Totals);
